import * as React from "react";
import {
  Dialog,
  CircularProgress,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Theme,
  makeStyles,
  createStyles,
} from "@material-ui/core";
import { CheckCircle, Cancel } from "@material-ui/icons";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divHead: {
      marginBottom: "0.5rem",
    },
    divCheckIcon: {
      paddingTop: "0.5rem",
    },
    success: {
      color: theme.palette.success.main,
      verticalAlign: "middle",
    },
    error: {
      color: theme.palette.error.main,
      verticalAlign: "middle",
    },
    spanMsg: {
      verticalAlign: "middle",
      marginLeft: "0.25rem",
    },
    divItem: {
      fontSize: "0.875rem",
      marginTop: "0.25rem",
      marginLeft: "1.75rem",
    },
    divMsg: {
      marginTop: "0.75rem",
    },
  })
);

export interface ConnectionCheckDialogState {
  open: boolean;
  loading: boolean;
  result: "" | "ok" | "ng"; // 文字列リテラル https://typescript-jp.gitbook.io/deep-dive/type-system/literal-types
  check: { connection: boolean; path: boolean };
  connection: {
    ip: string;
    port: string;
    path: string;
  };
}

interface Props {
  state: ConnectionCheckDialogState;
  setState: React.Dispatch<ConnectionCheckDialogState>;
}

/** 接続先設定チェックダイアログ */
export function ConnectionCheckDialog(props: Props) {
  const classes = useStyles();

  const { state, setState } = props;

  // 結果メッセージ生成処理
  const getResultMessage = () => {
    let component = <></>;
    if (!state.loading) {
      component = (
        <div>
          <div className={classes.divHead}>通信チェック</div>
          {state.check.connection ? (
            <div className={classes.divCheckIcon}>
              <CheckCircle className={classes.success} />
              <span className={classes.spanMsg}>通信に成功しました。</span>
            </div>
          ) : (
            <div className={classes.divCheckIcon}>
              <Cancel className={classes.error} />
              <span className={classes.spanMsg}>通信に失敗しました。</span>
            </div>
          )}
          <div className={classes.divItem}>
            IPアドレス：
            {state.connection.ip}
            &nbsp;&nbsp; ポート：
            {state.connection.port}
          </div>
          {state.check.path ? (
            <div className={classes.divCheckIcon}>
              <CheckCircle className={classes.success} />
              <span className={classes.spanMsg}>パスを確認できました。</span>
            </div>
          ) : (
            <div className={classes.divCheckIcon}>
              <Cancel className={classes.error} />
              <span className={classes.spanMsg}>
                パスが確認できませんでした。
              </span>
            </div>
          )}
          <div className={classes.divItem}>
            パス：
            {state.connection.path}
          </div>
          {state.result === "ng" ? (
            <div className={classes.divMsg}>設定を見直してください。</div>
          ) : (
            <></>
          )}
        </div>
      );
    }
    return component;
  };

  //--------------------
  // コンポーネント
  return (
    <Dialog
      open={state.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogContent>
        {/* DialogContentText は内部で <p>タグを使うため, 生のテキスト以外を内包すると警告が出るので, 使用しない */}
        {/* <DialogContentText id="alert-dialog-description"> */}
        {state.loading ? (
          <>
            <CircularProgress />
            <Typography component="span">通信チェック中です…</Typography>
          </>
        ) : (
          <></>
        )}
        {getResultMessage()}
        {/* </DialogContentText> */}
      </DialogContent>
      <DialogActions>
        {!state.loading ? (
          <Button
            // variant="contained"
            onClick={() => {
              setState({ ...state, open: false });
            }}
            color="primary"
            autoFocus
          >
            閉じる
          </Button>
        ) : (
          <></>
        )}
      </DialogActions>
    </Dialog>
  );
}
